import React from 'react';
import './styles.css';

const Heading = ({ children }) => {
  return <div className="Listview__Filters__Heading__root">{children}</div>;
};
export default Heading;
